import Footer from "../../components/Footer";
import LanImg_2 from "../../assets/img/ourStory.png";
import LanIcon_3 from "../../assets/img/Black.png";
import "../style.css";
import LanImg_1 from "../../assets/img/toeffl.png";
import LearnMoreSection from "./LanguageLearnMore";
export default function Toefl() {
  const learnMoreData = {
    pageName: "Toefl",
    heroSection: {
      header1: "TOEFL for",
      header2: "university entry",
      desc: "TOEFL is a globally recognised English language proficiency test for international students planning to study abroad.",
      rightImg: LanImg_1,
    },
    aboutTestSection: {
      img: LanImg_2,
      header: "What is the TOEFL English Test?",
      desc1:
        "The Test of English as a Foreign Language (TOEFL) is one of the world’s most established and widely recognised English language assessments. Accepted by more than 13,000 universities and institutions globally, it provides a comprehensive evaluation of all core language skills: reading, writing, listening and speaking.",
      desc2:
        "TOEFL offers several test formats to suit different needs, including the TOEFL iBT, TOEFL Essentials and TOEFL ITP. Among these, the TOEFL iBT remains the gold standard for academic purposes and is the version most commonly required by international universities as proof of English language competency.",
    },
    blueCardSection: {},
    differenceSection: {
      header: "What makes the TOEFL English Test different?",
      desc: "TOEFL iBT offers a structured and reliable way for you to assess your English language proficiency and your readiness to study abroad.",
      cards: [
        {
          img: LanIcon_3,
          header: "Available online and in-person",
          desc: "You can take the test at a certified test centre or from home, depending on your preference.",
        },
        {
          img: LanIcon_3,
          header: "Academic-focused testing",
          desc: "The test is designed with real university environments in mind, with tasks based on academic reading, listening, and discussions",
        },
        {
          img: LanIcon_3,
          header: "Frequent test availability",
          desc: "You can take the test from almost anywhere in the world, and test appointments are available up to six days a week",
        },
        {
          img: LanIcon_3,
          header: "Comprehensive scoring system",
          desc: "Each of the four sections of your test is graded separately so you can evaluate your reading, writing, listening, and speaking skills individually",
        },
      ],
    },
    testFormatSection: {
      header: "What is a good TOEFL score?",
      desc: "TOEFL scores are based on a total score of 120, with each section graded individually. Here’s an overview of the TOEFL scoring system:",
      tableData: {
        rowHeader: ["Skill", "Score range", "Proficiency levels"],
        rowData: [
          {
            column1: "Reading",
            column2: "0–30",
            column3: [
              "Advanced (24–30)",
              "High-intermediate (18–23)",
              "Low-intermediate (4–17)",
              "Below low-intermediate (0–3)",
            ],
          },
          {
            column1: "Listening",
            column2: "0–30",
            column3: [
              "Advanced (22–30)",
              "High-intermediate (17–21)",
              "Low-intermediate (9–16)",
              "Below low-intermediate (0–8)",
            ],
          },
          {
            column1: "Speaking",
            column2: "0–30",
            column3: [
              "Advanced (25–30)",
              "High-intermediate (20–24)",
              "Low-intermediate (16–19)",
              "Basic (10–15)",
              "Below basic (0–9)",
            ],
          },
          {
            column1: "Writing",
            column2: "0–30",
            column3: [
              "Advanced (24–30)",
              "High-intermediate (17–23)",
              "Low-intermediate (13–16)",
              "Basic (7–12)",
              "Below basic (0–6)",
            ],
          },
          {
            column1: "Total score",
            column2: "0–30",
            column3: ["The sum of all four section"],
          },
        ],
      },
    },
  };

  return (
    <div className="language-cert">
      <LearnMoreSection learnMoreData={learnMoreData} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
